import { createContext, useContext, useEffect, useMemo } from 'react';

import { messages } from './messages';

const LanguageContext = createContext();

// The interface language follows the device (C18): there is no selector, so the
// browser's own preference is read once and never changed from inside psy.
// Italian when the device prefers it, English otherwise.
//
// The document element's lang is set to match, so assistive technology reads
// the copy in the language it is written in even when the server guessed
// differently from Accept-Language.
export function LanguageProvider({ children }) {
  const language = useMemo(function() {
    if (navigator.language.toLowerCase().startsWith('it') === true) {
      return 'it';
    }

    return 'en';
  }, []);

  useEffect(function() {
    document.documentElement.lang = language;
  }, [ language ]);

  // translate turns a sentence a service answered with into this language,
  // and leaves it as it came when there is no translation for it.
  const value = useMemo(function() {
    const text = messages[ language ];

    // null is a field with nothing wrong, and stays null.
    const translate = function(sentence) {
      if (sentence == null) {
        return null;
      }

      if (typeof text.errors[ sentence ] === 'string') {
        return text.errors[ sentence ];
      }

      return sentence;
    };

    return { language, text, translate };
  }, [ language ]);

  return <LanguageContext.Provider value={ value }>{ children }</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
